<div class="container-fluid mb-5 pt-5">
  <div class="row">
    <div class="col-md-4">
      <div class="zoom_right_inner_panel">
        <ng-container *ngFor="let cartItem of selectedImage">
          <swiper [zoom]="{ minRatio: 1, maxRatio: 5 }" [spaceBetween]="0" [centeredSlides]="true" [slidesPerView]="1"
            [pagination]="{clickable: true}" class="mySwiper">
            <ng-template swiperSlide *ngFor="let image of cartItem?.images">
              <div class="swiper-zoom-container-main">
                <img #mainProductImage class="product-image" (click)="show()" [src]="imageBaseUrl + image" />
              </div>
            </ng-template>
          </swiper>
          <div class="expend-content">Tap image to expand</div>
          <div class="variants-container-image">
            <div class="swiper-slide-thumb" *ngFor="let image of cartItems?.variants" (click)="onColorSelect(image?.colorCode)"[ngClass]="{ 'selected': image.colorCode === selectedColor }">
              <img [src]="imageBaseUrl + image.images[0]" style="width: 80px; height: auto;cursor: pointer;" />
            </div>
           <!-- <div class="selcte-size-color-text"> Color : </div>
            <div *ngFor="let item of colorCodes" class="variant-inline" (click)="onColorSelect(item)"
              [ngClass]="{ 'selected': item === selectedColor }" [ngStyle]="{ 'background-color': item }">
            </div> -->
          </div>
          <div class="variants-container" *ngIf="sizes.length > 0">
            <div class="selcte-size-color-text">{{ getVariantLabel(sizes) }} : </div>
            <div class="size-options">
              <div *ngFor="let item of sizes" class="variant-inline-size" (click)="onSizeSelect(item)"
                [ngClass]="{ 'selected': item === selectedSize }">
                <div>{{item}}</div>
              </div>
            </div>
          </div>
          <label class="recommend" *ngIf="sizes.length > 0 && showCartItems">
            <b>{{selectedSize}}</b> is your Selected {{ getVariantLabel(sizes) }} <mat-icon
              class="green-icon">check</mat-icon>
          </label>

        </ng-container>
      </div>
    </div>
    <div class="col-md-8">
      <div class="zoom_right_panel">
        <div class="">
          <div class="card-title_1"><strong>{{cartItems.product_name | titlecase}}</strong></div>
          <div class="mrp-content" *ngIf="showCartItems"><span class="rates">₹{{cartItems.product_price}} </span>
            <span> </span> M.R.P : ₹ <del> 
              {{ cartItems.product_mrp_price }} </del>
              Save ₹ {{ getSavedAmount(cartItems) }}
          </div>
          <span class="mrp-content">Get it by
            <span class="delevery_date">Today </span>
          </span>
          <span class="mrp-content"> Free of Delivery by RuralX</span>
        </div>
        <div class="description-title">Product Description : </div>
        <div style="font-size: 13px; font-weight: 500;" [innerHTML]="cartItems.product_description"></div>
        <div class="mrp-content" *ngIf="showCartItems">In Stocks :
          <span
            [ngClass]="{'in-stock': selectedStock >=5,'limited-stock': selectedStock > 0 && selectedStock < 5,'out-stock': selectedStock === 0}">
            {{selectedStock >=5? 'In Stock': selectedStock > 0 && selectedStock <
              5? 'Limited Stock' : 'Out of Stock' }} </span>
        </div>
        <div class="pt-2 quantity-btn-align">
          <nav aria-label="quantity-navigation">
             <div class="mrp-content">Quantity:</div>
            <ul class="pagination">
              <li class="page-item"><a class="page-link" (click)="decrement()" >
                  <strong style="cursor: pointer;">-</strong></a>
              </li>
              <li class="page-item item-font"><a class="page-link qunt-back" *ngIf="showCartItems">{{counter}}</a></li>
              <li class="page-item"><a class="page-link" (click)="increment()">
                  <strong style="cursor: pointer;">+</strong></a>
              </li>
            </ul>
          </nav>
        </div>
        <div>
          <!-- <strong class="pt-2">
            <mat-icon id="locationMake" (click)="openDialog_()">location_on</mat-icon>
            <span class="delivery_title">Select Delivery Location</span>
          </strong> -->
          <div class="pt-1">
            <button class="btn btn-warning btn-md mb-2 mr-2 btn-align-buy" [disabled]="selectedStock === 0"
              (click)="$event.stopPropagation(); flyActiveSwiperImageToCart();addCart(cartItems)"> ADD TO CART
            </button>
            <button class="btn btn-danger btn-md btn-align-buy" (click)="buyNow(cartItems)"
              [disabled]="selectedStock === 0">
               BUY NOW 
              </button>
          </div>
          <div>
            <strong style="color:red;font-size: 11px;"> Secure Transaction </strong>
          </div>

        </div>

      </div>

    </div>

  </div>

  <!--Rating Summary Card -->
  <mat-card class="rating-summary-card">
    <div class="customer-review-title">Customer reviews</div>
    <div class="rating-summary-container">
      <!-- Left: Average Rating -->
      <div class="avg-rating">
        <div class="rating-point">{{summary?.avg_rating}}</div>
        <div class="stars">
          <mat-icon *ngFor="let s of getFullStars()">star</mat-icon>
          <mat-icon *ngIf="hasHalfStar()">star_half</mat-icon>
        </div>
        <p><strong> {{summary.total_reviews}}</strong> <small> Global Ratings</small></p>
        
      </div>
      <!-- Right: Rating Distribution -->
      <div class="rating-bars">
        <div class="bar-row" *ngFor="let rating of ratingSummary">
          <span class="star-text">{{rating.star}} star</span>
          <mat-progress-bar class="custom-bar" mode="determinate" [value]="rating.percent">
          </mat-progress-bar>
          <span class="rating-percent">{{rating.percent}}%</span>
        </div>
      </div>
    </div>
    <div class="button-aling-rating">
      <button mat-raised-button color="primary" (click)="writeReview()">
        Write Review
      </button>
    </div>
  </mat-card>

  <!-- Reviews List -->
  <div *ngFor="let review of visibleRatings">
    <mat-card class="review-card" *ngIf="review.verified_purchase == 1">
      <div class="review-header">
        <div class="stars">
          <mat-icon *ngFor="let s of [].constructor(review.rating)">star</mat-icon>
        </div>
        <div class="review-title">{{review.review_title | titlecase}}</div>
      </div>
      <p class="review-text">
        {{review.review_text | titlecase}}
      </p>
      <div class="review-images" *ngIf="review.review_images?.length">
        <img *ngFor="let img of review.review_images" [src]="imageBaseUrl + 'uploads/' + img" class="review-img" />
      </div>
      <div class="review-footer">
        <div>
          <strong>{{review.user_name | titlecase}}</strong>
          <span *ngIf="review.verified_purchase == 1" class="verified">
            ✔ Verified Purchase
          </span>
          <span class="date">
            {{review.created_at | date}}
          </span>
        </div>
      </div>
      <div class="helpfull-text" *ngIf="showCartItems"> <a (click)="markHelpful(review)"> 👍 Helpful ({{review.helpful_count}})</a></div>
    </mat-card>
  </div>
  <!-- Show More Button -->
<label class="show-more" *ngIf="productReview.length > 5"
        (click)="toggleRatings()">
  {{ showAll ? 'Show Less' : 'Show More' }} >>
</label>
</div>
<br>
<br>
<!-- model -->
<div [style.display]="showModal ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <span class="modal-title" id="myModalLabel">{{cartItems.product_name |titlecase}}</span>
        <div class="modal-footer" style="color:teal;font-weight: 700;">
          <mat-icon class="cross-close" data-dismiss="modal" (click)="hide()">close</mat-icon>
        </div>
      </div>
      <div class="pop-up-model">
        <!-- Main Swiper -->
        <ng-container *ngFor="let cartItem of selectedImage">
          <swiper #mainSwiper [zoom]="{ minRatio: 1, maxRatio: 5 }" [spaceBetween]="0" [centeredSlides]="true"
            [slidesPerView]="1" [thumbs]="{ swiper: thumbsSwiperRef?.swiperRef }" class="mySwiper">
            <ng-template swiperSlide *ngFor="let image of cartItem?.images">
              <div class="swiper-zoom-container responsive-image-container">
                <img [src]="imageBaseUrl + image" />
              </div>
            </ng-template>
          </swiper>
          <!-- Thumbs Swiper -->
          <swiper #thumbsSwiperRef [slidesPerView]="'auto'" [spaceBetween]="1" (swiper)="onThumbsSwiperInit($event)"
            [watchSlidesProgress]="true" class="thumbs-swiper">
            <ng-template swiperSlide class="swiper-slide-thumb" *ngFor="let image of cartItem?.images">
              <img [src]="imageBaseUrl + image" style="width: 80px; height: auto;cursor: pointer;" />
            </ng-template>
          </swiper>
        </ng-container>
      </div>
    </div>
  </div>
</div>